// Solutions.js (antigo Product.js)
import React, { useState, useCallback } from 'react';
import './Solutions.css';
import './HeroSection.css';
import './ImageCarousel.css';
import AnimateOnScroll from './AnimateOnScroll';
import HeroSection from './HeroSection';
import { pulmoscanData, pulmogameData, saasData, pulmoflowData, saasPulmoflowData } from './solutionsData';
// Imagens e textos agora vivem em solutionsData.js

// cards migrados para solutionsData

const Solutions = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const closeModal = useCallback(() => setSelectedImage(null), []);

  // Sem effects: reinit está encapsulado no ImageCarousel

  return (
    <section className="solutions" id="solutions">
      <AnimateOnScroll variant="fadeUp">
        <h2 className="solutions-title">Nossas Soluções</h2>
      </AnimateOnScroll>
      {/* Hero do PulmoScan */}
      <AnimateOnScroll variant="fadeUp" delay={100}>
      <HeroSection
        className="pulmoscan-hero"
        title={pulmoscanData.title}
        subtitle={pulmoscanData.subtitle}
        paragraphs={pulmoscanData.paragraphs}
        bullets={pulmoscanData.bullets}
        badges={pulmoscanData.badges}
        singleImage={pulmoscanData.singleImage}
        images={pulmoscanData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do PulmoGame */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="pulgomame-hero"
        title={pulmogameData.title}
        subtitle={pulmogameData.subtitle}
        paragraphs={pulmogameData.paragraphs}
        bullets={pulmogameData.bullets}
        badges={pulmogameData.badges}
        singleImage={pulmogameData.singleImage}
        images={pulmogameData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do Portal de Gerenciamento (SaaS) */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="saas-hero"
        title={saasData.title}
        subtitle={saasData.subtitle}
        paragraphs={saasData.paragraphs}
        bullets={saasData.bullets}
        badges={saasData.badges}
        singleImage={saasData.singleImage}
        images={saasData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do PulmoFlow */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="pulmoflow-hero"
        title={pulmoflowData.title}
        subtitle={pulmoflowData.subtitle}
        inDevelopment={pulmoflowData.inDevelopment}
        paragraphs={pulmoflowData.paragraphs}
        bullets={pulmoflowData.bullets}
        badges={pulmoflowData.badges}
        singleImage={pulmoflowData.singleImage}
        images={pulmoflowData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do Portal de Gerenciamento PulmoFlow */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="saas-pulmoflow-hero"
        title={saasPulmoflowData.title}
        subtitle={saasPulmoflowData.subtitle}
        inDevelopment={saasPulmoflowData.inDevelopment}
        paragraphs={saasPulmoflowData.paragraphs}
        bullets={saasPulmoflowData.bullets}
        badges={saasPulmoflowData.badges}
        singleImage={saasPulmoflowData.singleImage}
        images={saasPulmoflowData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>
    
      <AnimateOnScroll variant="fadeUp" delay={100}>
      <div className="features">
        <h3>Recursos Disponíveis</h3>
        <div className="feature-grid">
          <div className="feature-item">
            <span className="feature-icon">📱</span>
            <h4>PulmoScan</h4>
            <p>Software profissional para cadastro, avaliação e acompanhamento</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🎮</span>
            <h4>PulmoGame</h4>
            <p>Jogos interativos integrados para engajamento em treinamento</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🖥️</span>
            <h4>Portal SaaS PulmoScan</h4>
            <p>Administração web centralizada do ecossistema BTOne para clínicas e profissionais</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🧪</span> 
            <h4>Avaliações</h4>
            <p>PImáx e PEmáx com normalização e visualização em tempo real</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🗂️</span>
            <h4>Gerenciamento</h4>
            <p>Gestão de pacientes, fisioterapeutas, sessões e histórico</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">📊</span> 
            <h4>Relatórios</h4>
            <p>Relatórios inteligentes com exportação em PDF e compartilhamento</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">☁️</span>
            <h4>Dados na Nuvem</h4>
            <p>Sincronização segura em nuvem com acesso de qualquer lugar</p>
          </div>
          
          <div className="feature-item">
            <span className="feature-icon">🔗</span>
            <h4>Integração BTOne</h4>
            <p>Conexão BLE com o dispositivo para leitura e treino em tempo real</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🌬️</span>
            <h4>PulmoFlow</h4>
            <p>App para paciente coletar pico de fluxo e responder questionários ACT/CAT</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🖥️</span>
            <h4>Portal SaaS PulmoFlow</h4>
            <p>Plataforma web para o profissional analisar amostras e questionários enviados pelos pacientes</p>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🔗</span>
            <h4>Integração BTTwo</h4>
            <p>Medidor de pico de fluxo para monitoramento e envio de amostras ao médico</p>
          </div>
        </div>
      </div>
      </AnimateOnScroll>
      {/* Modal de imagem ampliada */}
      {selectedImage && (
        <div className="image-modal" onClick={closeModal}>
          <img src={selectedImage} alt="Visualização ampliada" />
        </div>
      )}
    </section>
  );
};

export default Solutions;
